import React, { useRef } from 'react';

import { type AnimationDefinition } from 'framer-motion';

import { AccordionVariant } from '@pkg/motion';
import { useMediaQuery } from '@pkg/providers';

import { Label, StyledFormMessage } from './FormMessage.style';

export interface FormMessageProps {
    message?: string;
    autoScroll?: boolean;
    error?: boolean;
}

export function FormMessage({ message = '', autoScroll = false, error = false }: FormMessageProps) {
    const { tablet } = useMediaQuery();
    const elementRef = useRef<HTMLDivElement>(null);

    // Alternatively, we could just call `scrollIntoView()` within
    // a useEffect(). For now, I think the animation even works well.
    function handleAnimationComplete(definition: AnimationDefinition) {
        if (elementRef.current && definition === AccordionVariant.Show) {
            elementRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <StyledFormMessage
            ref={elementRef}
            $error={error}
            onAnimationComplete={autoScroll && !tablet ? handleAnimationComplete : undefined}
        >
            <Label>{message}</Label>
        </StyledFormMessage>
    );
}
